import React, { useContext } from "react";
import cx from "classnames";

import global from "../../../scss/dhp.scss";

import { Icon } from "../../ui/icon";
import { EditorContext } from "../../../containers/editor/EditorLayout";
import useClippingPicture from "../../../hooks/useClippingPicture";

let style = Object.assign({}, global);

const DetachFrame = () => {
  const { metadata } = useContext(EditorContext);
  const { detachPicture, detachVideo } = useClippingPicture();

  const detachFromFrame = () => {
    let frameContentType = document.getElementById(metadata.activeWidgetId[0]).getAttribute("data-clipped");

    if (frameContentType === "image") detachPicture();
    if (frameContentType === "video") detachVideo();
  };
  return (
    <>
      <li className={cx(style["toolset-group"])}>
        <div className={cx(style["toolset-item"], style["detach-wrap"])}>
          <span className={cx(style["toolset-action"])} onClick={detachFromFrame}>
            <Icon icon="ui-cancel" />
            Detach from Frame
          </span>
        </div>
      </li>
    </>
  );
};

export default DetachFrame;
